import { OrgAdminConstants } from '../../../_constants';

const initialState = { getMasterModuleListLoading: true, data: '', error: false };

export function getMasterModuleListReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_MASTER_MODULE_LIST:
            return {
                getMasterModuleListLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_MASTER_MODULE_LIST:
            return {
                getMasterModuleListLoading: false,
                data: action.getMasterModuleList,
                error: false
            };
        case OrgAdminConstants.MASTER_MODULE_LIST_ERROR:
            return {
                getMasterModuleListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ModulePermissions/getMasterModuleList.reducer.js